export default "__VITE_ASSET__Bq$70g0E__"